module.exports = __webpack_public_path__ + "img/icon_card11.c4e2fee0.png";